<template>
    <div id="main">
        <loader v-if="isLoading" />
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />

        <div class="listing-header">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t('vincular-propriedade') }}
                </h1>
            </div>
            <div class="header-buttons">
                <button class="delete-btn" type="button" @click="onFecharModal">
                    {{ $t('cancelar') }}
                </button>
                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                    :disabled="talhoesList.length === 0"
                >
                    {{ $t('salvar') }}
                </button>
            </div>
        </div>

        <div class="search-and-filter">
            <div class="search-bar">
                <search-bar :onSearch="debouncedOnSearch" />
            </div>
        </div>

        <div class="registry-wrapper">
            <empty-table-message v-if="isEmpty" />
            <b-table
                v-else
                :data="talhoes"
                class="data-table"
                @sort="sortTable"
                backend-sorting
                checkable
                @check="checkSingleExecute"
                :checked-rows="talhoesList"
                :custom-is-checked="(selecionados, linha) => selecionados.uuid === linha.uuid"
                :is-row-checkable="verifyCheckableRows"
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="$t(f.label)"
                    :width="f.width"
                    :sortable="f.sortable"
                    :custom-sort="f.sortFn"
                >
                    <template v-slot="props">
                        <div v-if="f.key == 'propriedade'">
                            {{ props.row.propriedadepai.nome }}
                        </div>
                        <div v-else-if="f.key == 'area'">
                            {{ props.row.areapai.descricao }}
                        </div>
                        <div v-else-if="f.key == 'talhao'">
                            {{ props.row.descricao }}
                        </div>
                        <div v-else-if="f.key == 'unidademedidaarea'">
                            {{
                                props.row.propriedadepai.unidadeMedida.descricao +
                                '(' +
                                props.row.propriedadepai.unidadeMedida.sigla +
                                ')'
                            }}
                        </div>

                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </template>
                </b-table-column>
            </b-table>

            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
import AssPlanoSafraPropriedadeService from '@/services/agro/planosafra/AssPlanoSafraPropriedadeService';
import TalhaoService from '@/services/agro/TalhaoService';
import PlanoSafraService from '@/services/agro/planosafra/PlanoSafraService';
import Message from '@/models/Message';

export default {
    props: {
        uuidagro_planosafra: 0,
        idcliente: 0,
        currentUnidadeMedidaAreaId: 0,
    },
    data() {
        return {
            service: new AssPlanoSafraPropriedadeService(this.$http, this.$router),
            serviceTalhao: new TalhaoService(this.$http, this.$router),
            servicePlanoSafra: new PlanoSafraService(this.$http, this.$router),
            talhoes: [],
            talhoesList: [],
            currentUnidadeMedidaAreaIdFromTalhao: 0,
            isLoading: false,
            isLoadingTalhao: false,
            isEmpty: false,
            fields: [
                {
                    key: 'propriedade',
                    label: 'propriedade',
                    width: null,
                    sortable: false,
                    sortFn: null,
                },
                { key: 'area', label: 'area', width: null, sortable: false, sortFn: null },
                { key: 'talhao', label: 'talhao', width: null, sortable: false, sortFn: null },
                {
                    key: 'unidademedidaarea',
                    label: 'agro-unidademedidaarea',
                    width: null,
                    sortable: false,
                    sortFn: null,
                },
            ],
            idpropriedade: 0,
            siglaSelected: null,
            siglaSelect: [],
            planosafra: {
                id: null,
                uuidagro_planosafra: null,
                idcliente: null,
                idagrosafra: null,
                idcultivar: null,
            },
            talhao: {},
            debouncedOnSearch: null,
            talhoesLoading: false,
            queryFilter: '',
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            msgs: [],
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.carregarPlanoSafra(this.uuidagro_planosafra);
        this.carregarTalhoes();
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
    },
    methods: {
        carregarPlanoSafra() {
            // esse metodo está aqui para pegar o id do cliente
            this.isLoading = true;
            this.servicePlanoSafra
                .findByUuid(this.uuidagro_planosafra)
                .then((value) => {
                    this.planosafra = value.content;
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        carregarTalhoes(currentPage = 1) {
            // carregar a listage de talhoes que o usuario deseja vincular
            if (currentPage == 1 && this.pagination.currentPage != 1) {
                this.pagination.resetPagination = true;
            }
            this.isLoading = true;
            let params = [
                this.queryFilter != '' ? this.queryFilter : '.*',
                this.siglaSelected != '' ? 0 : this.siglaSelected,
            ];

            this.serviceTalhao
                .listAllByUnidadeMedida(
                    currentPage - 1,
                    this.pagination.perPage,
                    this.uuidagro_planosafra,
                    this.idcliente,
                    this.currentUnidadeMedidaAreaId, // Caso passe 0, mostra todas as propriedades, se não mostra apenas as com a unidade de medida definida
                    params
                )
                .then(this.mapItems)
                .then((value) => {
                    this.talhoes = value;
                    this.isEmpty = this.talhoes.length === 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os dados.');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map((m) => {
                return {
                    idtalhao: m.idtalhao,
                    uuid: m.uuid,
                    propriedadepai: m.propriedadepai,
                    areapai: m.areapai,
                    descricao: m.descricao,
                    area: m.area,
                };
            });
        },

        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarTalhoes(this.pagination.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarTalhoes();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarTalhoes(value.currentPage);
        },
        select(selected) {
            this.$emit('selected', selected);
        },
        save() {
            if (this.talhoesList.length > 0) {
                let assPlanoSafraTalhoes = [];
                this.talhoesList.forEach((talhao) => {
                    assPlanoSafraTalhoes.push({
                        uuidagro_planosafra: this.uuidagro_planosafra,
                        uuidtalhao: talhao.uuid,
                    });
                });

                this.isLoading = true;
                this.service
                    .save(assPlanoSafraTalhoes)
                    .then((value) => {
                        if (value.content === null) {
                            this.msgs.push(new Message('error', `${value.message}`, true));
                        } else {
                            this.$emit('fecharModal', true);
                            this.$root.showMessage(
                                'success',
                                'msg-sucesso-ao-adicionar-associacao'
                            );
                        }
                    })
                    .catch((e) => {
                        this.msgs.push(new Message('alert', e.body.message, true));
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            } else {
                this.msgs.push(new Message('error', 'msg-selecione-talhao', true));
                this.isLoading = false;
            }
        },
        checkSingleExecute(allSelected, z) {
            if (this.currentUnidadeMedidaAreaIdFromTalhao == 0 && allSelected.length > 0) {
                this.currentUnidadeMedidaAreaIdFromTalhao =
                    allSelected[0].propriedadepai.unidadeMedida.idunidademedidaarea;
            } else if (allSelected.length == 0) {
                this.currentUnidadeMedidaAreaIdFromTalhao = 0;
            }

            if (!z) {
                this.talhoesList = allSelected.filter((e) => {
                    return (
                        e.propriedadepai.unidadeMedida.idunidademedidaarea ==
                        this.currentUnidadeMedidaAreaIdFromTalhao
                    );
                });
            } else {
                if (
                    !this.talhoesList.some((x) => {
                        return x.uuid == z.uuid;
                    })
                ) {
                    this.talhoesList.push(z);
                } else {
                    this.talhoesList = this.talhoesList.filter((x) => {
                        return x.uuid != z.uuid;
                    });
                }
            }
        },
        verifyCheckableRows(row) {
            if (
                this.currentUnidadeMedidaAreaIdFromTalhao == 0 ||
                row.propriedadepai.unidadeMedida.idunidademedidaarea ==
                    this.currentUnidadeMedidaAreaIdFromTalhao
            ) {
                return true;
            }
            return false;
        },
        onFecharModal() {
            this.$emit('fecharModal', true);
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 20px 20px;

    .search-and-filter {
        .search-bar {
            width: 100%;
        }
        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }
}
</style>
